<template>
  <div id="app" :style="appStyle">
  <template v-if="!isNotFound">
    <Header/>
  </template>
  <div class="main">
    <router-view></router-view>
  </div>
  <template v-if="!isNotFound">
    <Footer/>
    <!-- APP 内嵌时不显示侧边悬浮栏 -->
    <SideBar v-if="showSideBar" />
  </template>
  </div>
</template>

<script setup>
import { provide, computed, onMounted, ref } from 'vue'
import { useSiteConfigStore } from '@/stores/SiteConfig'
import { useHead } from '@unhead/vue'
import Header from '@/pages/components/Header/index.vue'
import Footer from '@/pages/components/Footer/index.vue'
import SideBar from '@/pages/components/Sidebar/index.vue'
import { useRoute } from 'vue-router'
import { isInOunaApp } from '@/utils/platform'

const siteConfigStore = useSiteConfigStore()

/**
/**
 * 侧边悬浮栏显示控制
 * 默认不显示，仅在客户端挂载后且非APP环境才显示
 */
const showSideBar = ref(false)

onMounted(() => {
  // 延迟显示，确保在客户端环境且不在APP内
  if (!isInOunaApp()) {
    showSideBar.value = true
  }
})
const siteConfig = siteConfigStore
const curLang = `${__SITE_PROFILE__}`
// 将站点配置注入到应用中，使所有组件都可以访问
provide('siteConfig', siteConfig)

// 设置全局 CSS 变量，确保所有组件都能访问 headerMainColor
const appStyle = computed(() => ({
  '--header-main-color': siteConfigStore.headerMainColor || '#FF1F59'
}))

useHead({
  title: siteConfigStore.seo?.title || siteConfigStore.siteName || '欧那官网',
  meta: [
    { name: 'description', content: siteConfigStore.seo?.description || siteConfigStore.siteName || '这是一个全局描述' },
    { name: 'keywords', content: siteConfigStore.seo?.keywords || '这是全局关键词' },
    // Open Graph / SEO Image
    { property: 'og:image', content: `${siteConfigStore.cdnPrefix || ''}${siteConfigStore.seo?.image || ''}` },
    { property: 'og:title', content: siteConfigStore.seo?.title || siteConfigStore.siteName },
    { property: 'og:description', content: siteConfigStore.seo?.description || siteConfigStore.siteName }
  ],
  link: [
    // 动态配置网站图标 (Favicon)，使用各语言站点的 SEO 图片
    ...(siteConfigStore.seo?.image ? [{ 
      rel: 'icon', 
      type: 'image/png', 
      href: `${siteConfigStore.cdnPrefix || ''}${siteConfigStore.seo?.image}` 
    }] : []),
    //防止闪动
    // { rel: 'preload', as: 'image', href: `/website/images/${curLang}/logo.png` },
    // { rel: 'preload', as: 'image', href: `/website/images/${curLang}/logo-white.png` },
  ]
})

const route = useRoute()
const isNotFound = computed(() => route.name === 'NotFound')


</script>

<style>
#app {
  margin: 0 auto;
}

main {
  min-height: 400px;
}

</style>
